<template>
  <div class="Container" @click.prevent="handleClick">
    <img src="@/assets/Downloaded.png" />
  </div>
</template>

<script>
export default {
  name: 'DownloadedChip',
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.Container {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  background-color: white;
  line-height: 24px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.15);

  img {
    height: 100%;
    width: 100%;
  }
}
</style>
